import { render } from "./MainFooter.vue?vue&type=template&id=3bd63ca3&scoped=true"
import script from "./MainFooter.vue?vue&type=script&lang=js"
export * from "./MainFooter.vue?vue&type=script&lang=js"

import "./MainFooter.vue?vue&type=style&index=0&id=3bd63ca3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3bd63ca3"

export default script